import { render, staticRenderFns } from "./TourPlacementCombinationsList.vue?vue&type=template&id=4b759924"
import script from "./TourPlacementCombinationsList.vue?vue&type=script&lang=js"
export * from "./TourPlacementCombinationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports